<script lang="ts">
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Subline from "../../components/Subline.svelte";
    import IconImg from "../../components/IconImg.svelte";
    import BosIcon from "../../icons/BosIcon.svelte";
    import StadtwerkeIcon from "../../icons/StadtwerkeIcon.svelte";
    import MaritimIcon from "../../icons/MaritimIcon.svelte";
    import OepnvIcon from "../../icons/OEPNVIcon.svelte";
    import IndustrieIcon from "../../icons/IndustrieIcon.svelte";
    import FlughafenIcon from "../../icons/FlughafenIcon.svelte";
    import { t } from "../../helpers/translation";
</script>

<!-- <LightTheme /> -->
<!-- <Hero headline="zuverlässig und <br>schnell" small /> -->
<Hero small />

<Container>
    <Container max="600px" padding="4rem">
        <img
            src="https://liveicom.azureedge.net/sinus/img/logo.svg"
            alt="logo"
        />
    </Container>
    <!-- <center> -->
    <Headline>
        {@html $t("page.about.headline")}
    </Headline>
    <Subline>
        {@html $t("page.about.subline")}
    </Subline>

    <ul>
        <li>
            <strong>
                {@html $t("page.about.section.1.li.1")}
            </strong>
        </li>
        <li>
            <strong>
                {@html $t("page.about.section.1.li.2")}
            </strong>
        </li>
        <li>
            <strong>
                {@html $t("page.about.section.1.li.3")}
            </strong>
        </li>
        <li>
            <strong>
                {@html $t("page.about.section.1.li.4")}
            </strong>
        </li>
        <li>
            <strong>
                {@html $t("page.about.section.1.li.5")}
            </strong>
        </li>
    </ul>

    <p>
        {@html $t("page.about.section.1.p")}
    </p>

    <Gap height="4rem" />
    <div class="icon-card-container">
        <div class="icon-card">
            <IconImg svg={BosIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.bos")}
            </h3>
        </div>
        <div class="icon-card">
            <IconImg svg={StadtwerkeIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.stadtwerke")}
            </h3>
        </div>
        <div class="icon-card">
            <IconImg svg={MaritimIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.maritim")}
            </h3>
        </div>
        <div class="icon-card">
            <IconImg svg={OepnvIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.opnv")}
            </h3>
        </div>
        <div class="icon-card">
            <IconImg svg={IndustrieIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.industry")}
            </h3>
        </div>
        <div class="icon-card">
            <IconImg svg={FlughafenIcon} color="var(--yellow)" size="2.5em" />
            <Divider width="50%" />
            <h3>
                {@html $t("page.about.portfolio.airport")}
            </h3>
        </div>
    </div>

    <Gap height="6em" />
    <Subline>
        {@html $t("page.about.section.2.subline")}
    </Subline>
    <p>
        {@html $t("page.about.section.2.p.1")}
    </p>
    <p>
        {@html $t("page.about.section.2.p.2")}
    </p>

    <Gap height="6rem" />
    <Subline>
        {@html $t("page.about.section.3.subline")}
    </Subline>
    <ul>
        <li>
            {@html $t("page.about.section.3.li.1")}
        </li>
        <li>
            {@html $t("page.about.section.3.li.2")}
        </li>
    </ul>

    <Gap height="6rem" />
    <Subline>
        {@html $t("page.about.section.4.subline")}
    </Subline>
    <ul>
        <li>
            {@html $t("page.about.section.4.li.1")}
        </li>
        <li>
            {@html $t("page.about.section.4.li.2")}
        </li>
        <li>
            {@html $t("page.about.section.4.li.3")}
        </li>
        <li>
            {@html $t("page.about.section.4.li.4")}
        </li>
    </ul>
    <Gap height="6rem" />
    <Subline>
        {@html $t("page.about.section.5.subline")}
    </Subline>
    <ul>
        <li>
            {@html $t("page.about.section.5.li.1")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.2")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.3")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.4")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.5")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.6")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.7")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.8")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.9")}
        </li>
        <li>
            {@html $t("page.about.section.5.li.10")}
        </li>
    </ul>

    <!-- </center> -->
</Container>

<style lang="scss">
    @import "../../vars";

    .icon-card-container {
        margin-top: 2em;
        font-size: 1.5rem;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(8em, 1fr));
        gap: 1.5em;
        max-width: 800px;
        margin: auto;
        @media (max-width: 800px) {
            font-size: 1.1rem;
        }
        // @media (max-width: 650px) {
        //     grid-template-columns: 1fr 1fr;
        // }
    }
    .icon-card {
        height: 8em;
        min-width: 8em;
        // background-color: red;
        text-align: center;
        border: 1px solid $yellow;
        border-radius: 1em;
        padding: 1em;
        display: flex;
        align-items: center;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        transition: 0.1s ease-in-out;
        transform: scale(1);
        :global(svg) {
            height: 2em;
            width: auto;
        }
        &:hover {
            transform: scale(1.1);
            background-color: $green;
            border-color: $green;
            :global(*) {
                color: white !important;
                fill: white !important;
            }
        }
        h3 {
            font-size: 0.8em;
            line-height: 1.3;
            font-weight: 500;
            color: $yellow;
            margin-top: 0;
            margin-bottom: 0;
        }
    }
</style>
